import { getAuthToken } from '../../../lib/auth';

export const emailApi = {

    getProgressStream: (onMessage: (data: any) => void, onError?: (error: any) => void) => {
        const token = getAuthToken();
        const url = `${process.env.REACT_APP_API_URL || ''}crm/email/progress/stream`;
        const abortController = new AbortController();

        fetch(url, {
            headers: {
                'Authorization': `Bearer ${token}`
            },
            signal: abortController.signal
        }).then(async response => {
            if (!response.body) throw new Error('No readable stream');
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n');
                buffer = lines.pop() || '';

                for (const line of lines) {
                    if (line.startsWith('data: ')) {
                        const dataStr = line.slice(6).trim();
                        if (!dataStr) continue;
                        try {
                            const data = JSON.parse(dataStr);
                            onMessage(data);
                        } catch (e) {
                            // Ignore invalid JSON
                        }
                    }
                }
            }
        }).catch(err => {
            if (err.name === 'AbortError') return;
            if (onError) onError(err);
        });

        return () => abortController.abort();
    },
};
